<template>
  <div class="empadronamiento__intro__main__form__container-item" :class="(value != null && value != '') || focused ? 'fieldFocused':''">
    <label>{{placeholder}}</label>
    <input
      class="empadronamiento__intro__main__form__container-form"
      :class="{'has-error': invalid}"
      :type="type"
      :name="name"
      :value="value"
      :disabled="disabled"
      @focus="focused = true"
      @blur="$emit('blur', $event.target.value)"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      focused: false
    };
  },
  props: {
    type: {
      type: String,
      default: "text",
      validator: function(value) {
        if (value === "date") return false;
        return (["text", "number", "password", "tel", "email"].indexOf(value) !== -1
        );
      }
    },
    value: {
      type: [String, Boolean, Number, Object],
      default: ""
    },
    name: String,
    placeholder: String,
    invalid: Boolean,
    disabled: {
      type:Boolean,
      default: false
    }
  }
};
</script>
